module.exports = __webpack_public_path__ + "static/img/play-intro-img-m-1.d293027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-intro-img-m-1.png
// module id = OIeX
// module chunks = 2 3